class Loader {
  private loader: HTMLElement;
  private canvas;
  private logo: HTMLElement;
  private ctx: CanvasRenderingContext2D;
  private beginX  = 135;
  private beginY = 35;
  private roadId = 0;
  private road: [number[]] = [
    [2, 12, 4],
    [1, -74, 0],
    [2, 12, 3],
    [1, 0, 47],
    [2, 12, 2],
    [1, 5, 0],
    [1, 0, 27],
    [1, 23, -25],
    [1, 10, 5],
    [1, 15, -9],
    [1, 17, 5],
    [1, 16, -15]
  ];
  private color = '#3ea9f5';

  constructor() {
    this.initLoader();
    this.initCanvas();
    this.logo = document.getElementById('mainPreloaderLogo');
    // Отслеживаем событие бутстрапа angular, и заканчиваем анимацию когда приложение запускается
    // (<any>window).bootstrapApp.then(() => {
    //   this.moveAnimation();
    // });
  }

  initLoader() {
    this.loader = document.getElementById('mainPreloader');
  }

  initCanvas() {
    this.canvas = document.getElementById('mainPreloaderCanv');
    this.canvas.height = 130;
    this.canvas.width = 400;
    this.ctx = this.canvas.getContext('2d');
  }

  animate(type, fullPath, fn, callback) {
    let t = 0;
    const animateStep = () => {
      setTimeout(() => {
        const coords = fn(t);
        if (type === 1) {				// Draw line
          this.ctx.beginPath();
          this.ctx.strokeStyle = this.color;
          this.ctx.lineWidth = 3;
          this.ctx.arc(coords.x + this.beginX, coords.y + this.beginY, 1, 0, Math.PI * 2, true);
          this.ctx.stroke();
        } else if (type === 2) {		// Draw arc
          this.ctx.beginPath();
          this.ctx.strokeStyle = this.color;
          this.ctx.lineWidth = 5;
          this.ctx.arc(coords.x + this.beginX, coords.y + this.beginY, coords.radius, coords.startAngle, coords.endAngle, true);
          this.ctx.stroke();
        }
        t += 1;
        if (t <= fullPath) {
          animateStep();
        } else {
          callback();
        }
      }, 5);
    };
    animateStep();
  }

  finish() {
    const preloader = document.getElementById('mainPreloader');
    this.logo.classList.add('preloaderMove');
    this.logo.addEventListener('animationend', () => {
      preloader.classList.add('fadeOut');
      preloader.addEventListener('animationend', () => {
        preloader.setAttribute('hidden', 'hidden');
        (<any>window).bootstrapFinish = true;
      });
    });
  }

  public roadGo() {
    const finished = (<any>window).bootstrapFinish;
    let roadStep = this.road[this.roadId];
    if (!roadStep) {
      if (finished) {
        return;
      } else {
        this.roadId = 0;
        roadStep = this.road[this.roadId];
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.beginY = 35;
        this.beginX = 135;
      }
    }

    const animateType = roadStep[0];
    let xto, yto, fullPath, animateHandler;

    if (animateType === 1) {
      xto = roadStep[1];
      yto = roadStep[2];
      fullPath = Math.sqrt(xto * xto + yto * yto);
      animateHandler = (t) => {
        return {fromX: this.beginX , fromY: this.beginY , x: xto / fullPath * t, y: yto / fullPath*t};
      };
    } else if (animateType == 2) {
      let radius = roadStep[1];
      let direct = roadStep[2];
      xto = (direct == 4 ? -1 : direct ==3 ? -1 : direct == 2 ? 1 : 0)*radius;
      yto = (direct == 4 ? -1 : direct ==3 ? 1 : direct==2 ? 1: 0)*radius;

      let sect = Math.PI / 2;

      fullPath = radius/2;
      animateHandler = function(t) {
        return {
          x: (direct==4 ? -1 : direct==3 ? 0 : direct==2 ? 1 :0)*radius,
          y:(direct==4 ? 0: direct == 3 ? 1 : direct==2 ?  0: 0)*radius,
          radius: radius,
          startAngle: sect*direct,
          endAngle:sect*direct - sect/fullPath*t
        };
      };
    }

    this.animate(animateType, fullPath, animateHandler, () => {
      this.roadId++;
      this.beginX += xto;
      this.beginY += yto;
      this.roadGo();
    });
  }
}

export default new Loader();



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/loader.ts